import React, { ReactNode } from 'react';
import { Router as ResourceRouter } from 'react-resource-router';
import { createBrowserHistory, History } from 'history';
import { routes } from './routes';

interface RouterProps {
  history?: History;
  onPrefetch?: (args: any) => void;
  children: ReactNode;
}

export const Router: React.FC<RouterProps> = ({ history, onPrefetch, children }) => {
  return (
    <ResourceRouter routes={routes} history={history || createBrowserHistory()} onPrefetch={onPrefetch}>
      {children}
    </ResourceRouter>
  );
};
